import React from 'react';
import { RARITY } from '../../lib/badgeDefinitions';
import { formatBadgeDate } from './badgeHelpers';

/**
 * Single badge tile used both in horizontal carousels and in the "see all" grid.
 * Locked badges are greyed out; secret+locked badges are masked ("???" + ❓).
 */
function BadgeCard({ badge, stats, earned, earnedAt, selected, onClick }) {
  const rarity = RARITY[badge.rarity] || RARITY.comune;
  const masked = badge.secret && !earned;
  // Su un badge bloccato non-segreto mostriamo il progresso della sfida (es. 3/10).
  const showProgress = !earned && !masked && badge.target > 0 && stats && badge.getProgress;
  const current = showProgress ? Math.min(badge.getProgress(stats), badge.target) : 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className="shrink-0 w-24 flex flex-col items-center gap-1.5 text-center snap-start focus:outline-none"
    >
      <div
        className={`relative w-20 h-20 rounded-2xl flex items-center justify-center ring-1 bg-gradient-to-b transition-transform active:scale-95 ${
          earned ? `${rarity.glow} ${rarity.ring}` : 'from-gray-100 to-gray-50 ring-gray-200'
        }`}
      >
        <span className={`text-4xl ${earned ? '' : 'grayscale opacity-40'}`}>
          {masked ? '❓' : badge.icon}
        </span>

        {!earned && (
          <span className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-gray-700 text-white text-[11px] flex items-center justify-center shadow ring-2 ring-white">
            🔒
          </span>
        )}
        {selected && (
          <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-primary-600 text-white text-[11px] flex items-center justify-center shadow ring-2 ring-white">
            ★
          </span>
        )}
      </div>

      <span
        className={`text-xs font-semibold leading-tight line-clamp-2 ${
          earned ? 'text-gray-800' : 'text-gray-400'
        }`}
      >
        {masked ? '???' : badge.name}
      </span>

      {earned && earnedAt ? (
        <span className="text-[10px] text-gray-400 leading-none">{formatBadgeDate(earnedAt)}</span>
      ) : showProgress ? (
        <span className="text-[10px] font-semibold text-primary-500 leading-none">
          {current}/{badge.target}
        </span>
      ) : null}
    </button>
  );
}

export default BadgeCard;
